import ParenthesesOpenToken from './tokens/ParenthesesOpenToken';
import ParenthesesCloseToken from './tokens/ParenthesesCloseToken';
import SetOpenToken from './tokens/SetOpenToken';
import SetCloseToken from './tokens/SetCloseToken';
import ExponentiationToken from './tokens/ExponentiationToken';
import CommaToken from './tokens/CommaToken';
import PlusToken from './tokens/PlusToken';
import MinusToken from './tokens/MinusToken';
import ProductToken from './tokens/ProductToken';
import DivisionToken from './tokens/DivisionToken';
import NumberToken from './tokens/NumberToken';
import SymbolToken from './tokens/SymbolToken';
import VectorOpenToken from './tokens/VectorOpenToken';
import VectorCloseToken from './tokens/VectorCloseToken';
import SpaceToken from './tokens/SpaceToken';
import AnalysisMode from './AnalysisMode';

export default class LexicalAnalyzer {

	public static execute (formula: string, analysisMode: AnalysisMode) {
		const characters = formula.split('');

		const tokens: any[] = [];

		let value = '';

		for (let i = 0; i < characters.length; i++) {
			const character = characters[i];
			const nextCharacter = i + 1 === characters.length ? null : characters[i + 1];

			if (character === ' ') {
				tokens.push(new SpaceToken());
			} else if (character === '{') {
				tokens.push(new SetOpenToken());
			} else if (character === '}') {
				tokens.push(new SetCloseToken());
			} else if (character === '<') {
				tokens.push(new VectorOpenToken());
			} else if (character === '>') {
				tokens.push(new VectorCloseToken());
			} else if (character === '^') {
				tokens.push(new ExponentiationToken());
			} else if (character === '(') {
				tokens.push(new ParenthesesOpenToken());
			} else if (character === ')') {
				tokens.push(new ParenthesesCloseToken());
			} else if (character === ',') {
				tokens.push(new CommaToken());
			} else if (character === '+') {
				tokens.push(new PlusToken());
			} else if (character === '-') {
				tokens.push(new MinusToken());
			} else if (character === '*') {
				tokens.push(new ProductToken());
			} else if (character === '/') {
				tokens.push(new DivisionToken());
			} else if (this.isDigit(character)) {
				value = value + character;
				if (!this.isDigit(nextCharacter)) {
					tokens.push(new NumberToken(Number(value)));
					value = '';
				}
			} else {
				value = value + character;
				if (analysisMode === AnalysisMode.MATH || !this.isLetter(nextCharacter)) {
					tokens.push(new SymbolToken(value));
					value = '';
				}
			}
		}

		return tokens;
	}

	private static isDigit (character: string | null) {
		if (character === null) {
			return false;
		}

		return '0123456789'.split('').includes(character);
	}

	private static isLetter (character: string | null) {
		if (character === null) {
			return false;
		}

		return 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').includes(character);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/parsing/LexicalAnalyzer.ts